import React, { useState, useEffect } from 'react';

var statusMap = {
  'pending': { label: '待处理', color: '#f6ad55', bg: '#fffaf0' },
  'contacted': { label: '已联系', color: '#667eea', bg: '#f0f0ff' },
  'approved': { label: '已通过', color: '#38a169', bg: '#e6ffed' },
  'rejected': { label: '已拒绝', color: '#e53e3e', bg: '#fff5f5' },
};

export default function PartnerApplicationsPage() {
  var stateArr = useState([]);
  var items = stateArr[0];
  var setItems = stateArr[1];
  var stateArr2 = useState(true);
  var loading = stateArr2[0];
  var setLoading = stateArr2[1];
  var stateArr3 = useState({ total: 0, pending: 0 });
  var stats = stateArr3[0];
  var setStats = stateArr3[1];

  var fetchItems = function() {
    setLoading(true);
    fetch('/cms/api/showcase/partner-applications')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data.success) setItems(data.data || []);
        setLoading(false);
      })
      .catch(function() { setLoading(false); });
  };

  var fetchStats = function() {
    fetch('/cms/api/showcase/partner-applications/stats')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data.success) setStats(data.data);
      });
  };

  var updateStatus = function(id, status) {
    fetch('/cms/api/showcase/partner-applications/' + id + '/status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ status: status })
    })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data.success) {
          setItems(items.map(function(i) {
            return i.id === id ? Object.assign({}, i, { status: status }) : i;
          }));
          fetchStats();
        }
      });
  };

  useEffect(function() {
    fetchStats();
    fetchItems();
  }, []);

  return React.createElement('div', { style: { padding: 24, maxWidth: 1200, margin: '0 auto' } },
    React.createElement('h2', { style: { fontSize: 22, fontWeight: 700, marginBottom: 4 } }, '🤝 合作申请管理'),
    React.createElement('p', { style: { color: '#888', marginBottom: 20 } }, 'AI 广场博小兔体验基地合作申请'),

    // 统计卡片
    React.createElement('div', { style: { display: 'flex', gap: 16, marginBottom: 24 } },
      [
        { label: '申请总数', value: stats.total, color: '#667eea' },
        { label: '待处理', value: stats.pending, color: '#f6ad55' },
      ].map(function(s) {
        return React.createElement('div', { key: s.label, style: { flex: 1, background: '#fff', borderRadius: 12, padding: '20px 24px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', borderLeft: '4px solid ' + s.color } },
          React.createElement('div', { style: { fontSize: 13, color: '#999' } }, s.label),
          React.createElement('div', { style: { fontSize: 28, fontWeight: 700, color: '#333', marginTop: 4 } }, s.value)
        );
      })
    ),

    // 列表
    loading ?
      React.createElement('div', { style: { textAlign: 'center', color: '#999', padding: 48 } }, '加载中...')
    : items.length === 0 ?
      React.createElement('div', { style: { textAlign: 'center', color: '#999', padding: 48 } }, '暂无申请')
    : React.createElement('table', { style: { width: '100%', borderCollapse: 'collapse', background: '#fff', borderRadius: 12, overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' } },
      React.createElement('thead', null,
        React.createElement('tr', { style: { background: '#f8f9fa', borderBottom: '2px solid #e0e0e0' } },
          ['ID', '企业名称', '联系人', '手机号', '类型', '状态', '日期', '操作'].map(function(h) {
            return React.createElement('th', { key: h, style: { padding: '12px 16px', fontSize: 13, fontWeight: 600, color: '#666', textAlign: 'center' } }, h);
          })
        )
      ),
      React.createElement('tbody', null,
        items.map(function(item) {
          var st = statusMap[item.status] || statusMap['pending'];
          return React.createElement('tr', { key: item.id, style: { borderBottom: '1px solid #f0f0f0' } },
            React.createElement('td', { style: tdStyle }, item.id),
            React.createElement('td', { style: Object.assign({}, tdStyle, { maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }) }, item.company),
            React.createElement('td', { style: tdStyle }, item.contact),
            React.createElement('td', { style: tdStyle }, item.phone),
            React.createElement('td', { style: tdStyle }, item.type || '-'),
            React.createElement('td', { style: tdStyle },
              React.createElement('span', { style: { display: 'inline-block', padding: '2px 10px', borderRadius: 12, fontSize: 12, background: st.bg, color: st.color } }, st.label)
            ),
            React.createElement('td', { style: Object.assign({}, tdStyle, { fontSize: 12 }) }, (item.created_at || '').substring(0, 10)),
            React.createElement('td', { style: tdStyle },
              item.status === 'pending' ?
                React.createElement('div', { style: { display: 'flex', gap: 6, justifyContent: 'center' } },
                  React.createElement('button', {
                    onClick: function() { updateStatus(item.id, 'contacted'); },
                    style: { padding: '4px 10px', border: 'none', borderRadius: 6, background: '#667eea', color: '#fff', fontSize: 12, cursor: 'pointer' }
                  }, '已联系'),
                  React.createElement('button', {
                    onClick: function() { updateStatus(item.id, 'approved'); },
                    style: { padding: '4px 10px', border: 'none', borderRadius: 6, background: '#38a169', color: '#fff', fontSize: 12, cursor: 'pointer' }
                  }, '通过'),
                  React.createElement('button', {
                    onClick: function() { updateStatus(item.id, 'rejected'); },
                    style: { padding: '4px 10px', border: 'none', borderRadius: 6, background: '#e53e3e', color: '#fff', fontSize: 12, cursor: 'pointer' }
                  }, '拒绝')
                )
              :
                React.createElement('span', { style: { fontSize: 12, color: '#999' } }, '已处理')
            )
          );
        })
      )
    )
  );
}

var tdStyle = { padding: '12px 16px', fontSize: 13, color: '#333', textAlign: 'center' };
